export default function ({ $auth, redirect }) {
  if (!$auth.user.all_roles.some(e=>e.includes('Admin'))) {
    return redirect('/')
  }
}